:host {
  display: none;
  width: 100%;
  height: 100%;
  background-color: var(--white-layout-302-level-1-elevation);
}

:host([data-is-visible]) {
  display: block;
}

.form-section {
  width: 100%;
  height: auto;
  margin-bottom: calc(4 * var(--spacer));
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}

.hidden {
  display: none;
}
